import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import './AutoCarousel.scss';
import PauseCircleFilledOutlinedIcon from '@material-ui/icons/PauseCircleFilledOutlined';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

const useStyles = makeStyles(theme => ({
  helpMeDecideCarousel: {
    '& li': {
      textIndent: 'unset'
    },
    '& .normal': {
      backgroundColor: `${theme.palette.primary.main}`,
      height: '10px',
      width: 'inherit',
      border: 'none',
      "&:focus": {
        outline: 'none',
      }
    },
    outline: 'none'
  }
}));

export default function AutoCarousel(props) {
  const classes = useStyles();
  const [index, setIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const handleSelect = (selectedIndex, event, isFromIndicator = false) => {
    if (!autoPlay && !isFromIndicator) return;
    setIndex(selectedIndex);
  };

  const toggleSlider = () => {
    setAutoPlay(!autoPlay);
  }

  const handleKeyDown = (e) => {
    const items = props.data
    if (e.keyCode === 37) {
      if (index === 0) {
        setIndex(items.length - 1)
      } else {
        setIndex(index - 1)
      }
    }
    else if (e.keyCode === 39) {
      if (index === items.length - 1) {
        setIndex(0)
      } else {
        setIndex(index + 1)
      }
    }
  }

  return (
    <div className="auto-carousel">
      <Carousel indicators={false} keyboard={true} tabIndex='0' activeIndex={index} onSelect={handleSelect}>
        {props.data.map((d, i) =>
          <Carousel.Item key={i}>
            {d}
          </Carousel.Item>
        )}
      </Carousel>
      <div className={`${classes.helpMeDecideCarousel} ${props.showCircle ? 'circle-carousel' : ''}`}>
        <ol className={props.circleIndicators ? 'carousel-circle-indicators mt-2' : 'carousel-indicators'}>
          {props.data.map((item, i) => {
            if (props.circleIndicators) {
              return (
                <div className={`circle ${index === i ? 'showColor' : 'hideColor'}`}
                  key={i}
                  tabIndex="0"
                  role="button"
                  onClick={(e) => handleSelect(i, e, true)}
                  onKeyDown={(e) => handleKeyDown(e)} aria-label={i} id={i}>
                </div>
              )
            }
            return (<li
              key={i}
              className={index === i ? "active" : ""}
            >
              <button className="normal"
                onKeyDown={(e) => handleKeyDown(e)}
                aria-label={i}
                tabIndex="0"
                role="button"
                id={i}
                onClick={(e) => handleSelect(i, e, true)}>
              </button>
            </li>)
          })}
        </ol>
      </div>

      {
        props.hidePlayButton ? null : <div className='button-toggle'>
          <button className="buttonToggle" onClick={toggleSlider} id="toggleCarousel">{autoPlay ? <span><PauseCircleFilledOutlinedIcon /></span> : <span><PlayCircleFilledIcon /></span>}</button>
        </div>
      }
    </div >
  )
}

AutoCarousel.propTypes = {
  data: PropTypes.array.isRequired,
  hidePlayButton: PropTypes.bool,
  circleIndicators: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Widgets/AutoCarousel/AutoCarousel.js